import service from '@/router/axios'

// 获取媒体列表
export const getChannelName = (params) => {
  return service({
    url: '/account/channel/name',
    method: 'get',
    params
  })
}

// 获取DSP列表名称
export const getDspName = (params) => {
  return service({
    url: '/account/dsp/name',
    method: 'get',
    params
  })
}

// 获取DSP列表名称2
export const getDspName2 = (params) => {
  return service({
    url: '/account/dsp/name/slot/flow',
    method: 'get',
    params
  })
}

// 获取媒体广告位名称
export const getDspSlotName = (params) => {
  return service({
    url: '/slot/dsp/name',
    method: 'get',
    params
  })
}

// 模糊查询媒体广告位名称
export const getDspSlotDimName = (params) => {
  return service({
    url: '/slot/dsp/dim/name',
    method: 'get',
    params
  })
}

// 获取CPD应用报表广告位名称
export const getDspApplyName = (params) => {
  return service({
    url: '/slot/dsp/cpd/name',
    method: 'get',
    params
  })
}

// 获取CPD应用报表标签名称
export const getDspTagName = (params) => {
  return service({
    url: '/Dsp/getTagList',
    method: 'get',
    params
  })
}

// 获取媒体广告位列表
export const getChannelSlotName = (params) => {
  return service({
    url: '/slot/channel/name',
    method: 'get',
    params
  })
}

// 获取媒体应用
export const getChannelAppName = (params) => {
  return service({
    url: '/endApp/appAdmin/nameandid',
    method: 'get',
    params
  })
}

// 获取广告尺寸大小
export const getSlotSize = (params) => {
  return service({
    url: '/slotSize/getSlotSize',
    method: 'get',
    params
  })
}

// 获取预算类型
export const getSlotBudget = (params) => {
  return service({
    url: '/slotBudget/getSlotBudget',
    method: 'get',
    params
  })
}

// 获取广告类型名称
export const getSlotType = (params) => {
  return service({
    url: '/slot/getTypeName',
    method: 'get',
    params
  })
}

export const getHeatMap = (params) => {
  return service({
    url: '/webCoordDefine/heatmap',
    method: 'get',
    params
  })
}
